module.exports = __webpack_public_path__ + "media/images/skebi/icon-bed-6cbfcc5b15f436d9cdc80341ad49f05f.png";